import { Component } from '@angular/core';
import packageJson from '../../package.json';
import { ApisService } from './shared/services/api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = packageJson.name;

  public version: string = packageJson.version;

  constructor(
    public api: ApisService
  ) {
    console.log('ERPat Rapol v'+this.version+' © 2023. All rights reserved. Made possible by BytesCarfter.');
  }
}
